import Loading from '../../../Common/Loading';
import { GeneralEvolutionChart } from './GeneralEvolutionChart';
import { HumanResourcesEvolutionChart } from './HumanResourcesEvolutionChart';
import { ServicesEvolutionChart } from './ServicesEvolutionChart';
import { SizeEvolutionChart } from './SizeEvolutionChart';
import { StructureEvolutionChart } from './StructureEvolutionChart';
import { useIDCRASChartsDataContext } from './hooks/useIDCRASChartsDataContext';


export const Charts = () => {
    const { isLoading } = useIDCRASChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="chats-indicators-side-by-side-dashboards">
                <GeneralEvolutionChart />
            </div>
            <div className='chats-indicators-side-by-side-dashboards'>
                <HumanResourcesEvolutionChart/>
                <StructureEvolutionChart/>
            </div>
            <div className='chats-indicators-side-by-side-dashboards'>
                <ServicesEvolutionChart/>
                <SizeEvolutionChart/>
            </div>
        </>
    );
};

